/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import ChatSection from "./components/ChatSection/ChatSection";
import CustomeVoiceAddon from "./components/CustomeVoice/index";
import SettingSection from "./components/SettingSection/Setting";
import Sidebar from "./components/Sidebar/Sidebar";
import SlideSection from "./components/Slide/index";
import UserDetails from "./components/UserDetails/UserDetails";
import { getLanguage } from "./store/auth-action";
import { uiAction } from "./store/ui-gemini";
import ReactOnboardingTour from "./components/ReactOnboardingTour";
import SubscriptionRequiredModal from "./components/Ui/SubscriptionRequiredModal";

function App() {
  const dispatch = useDispatch();
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [isCompletionModalOpen, setIsCompletionModalOpen] = useState(false);
  const [isTourSeen, setIsTourSeen] = useState(false);
  const [tourCompletionCount, setTourCompletionCount] = useState(0);
  const [isManualTourActive, setIsManualTourActive] = useState(false);
  const settingsShow = useSelector((state) => state.ui.isSettingsShow);
  const isAdvanceGeminiPrompt = useSelector((state) => state.ui.isAdvanceShow);

  const isShowCustomVoiceAddon = useSelector(
    (state) => state.ui.isShowCustomVoiceAddon
  );

  const isDark = useSelector((state) => state.ui.isDark);
  const isUserDetails = useSelector((state) => state.ui.isUserDetailsShow);
  const isLogin = useSelector((state) => state.auth.isLogin);
  const isSidebarLong = useSelector((state) => state.ui.isSidebarLong);
  const isShowSlide = useSelector((state) => state.ui.isShowSlide);
  const [hasSlideShown, setHasSlideShown] = useState(false);
  const [slideClosed, setSlideClosed] = useState(false);
  const [hslideFlag, setHslideFlag] = useState(false);

  const settingHandler = () => {
    if (settingsShow === true) {
      dispatch(uiAction.toggleSettings());
    }
    if (isAdvanceGeminiPrompt === true) {
      dispatch(uiAction.toggleAdvanceShow());
    }

    if (isUserDetails === true) {
      dispatch(uiAction.toggleUserDetailsShow());
    }
  };
  useEffect(() => {
    dispatch(getLanguage());
  }, []);

  useEffect(() => {
    const getLocalTheme = localStorage.getItem("theme");
    const theme = getLocalTheme || "light";
    document.documentElement.setAttribute("data-theme", theme);
  }, [isDark]);

  useEffect(() => {
    // Read tour completion count to allow max 1 run
    try {
      const completionCount = parseInt(localStorage.getItem('tour:chat-like:v2:count') || '0');
      setTourCompletionCount(completionCount);
      if (completionCount >= 1) {
        setIsTourSeen(true); // Block tour if already completed 1 time
      }
    } catch {}
  }, []);

  useEffect(() => {
    // Sync localStorage "hslide" to allow immediate start if already completed before
    const readHSlide = () => {
      try {
        const v = localStorage.getItem('hslide');
        const ok = v === 'true' || v === 'yes';
        setHslideFlag(ok);
        if (ok) {
          setHasSlideShown(true);
          setSlideClosed(true);
        }
      } catch {}
    };
    readHSlide();
    const onStorage = (e) => {
      if (e.key === 'hslide') readHSlide();
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useEffect(() => {
    // Detect the slide lifecycle: only start tour after slide was shown at least once and then closed
    if (isShowSlide) {
      setHasSlideShown(true);
    } else if (hasSlideShown) {
      setSlideClosed(true);
    }
  }, [isShowSlide, hasSlideShown]);

  // Tour will be rendered only when slide is hidden via Redux (isShowSlide === false)

  useEffect(() => {
    setTimeout(() => {
      const isShowIntroAlready = localStorage.getItem("isTutorialShow") || "no";
      console.log(isShowIntroAlready);
      if (isShowIntroAlready === "no") {
        dispatch(uiAction.userIntroPromptHandler({ introPrompt: true }));
        dispatch(uiAction.toggleTutorial());

        localStorage.setItem("isTutorialShow", "yes");
      }
    }, 3000);
  }, [dispatch]);

  // Disable auto-open slide on app mount; slide will be opened explicitly via UI actions

  // Listen for manual tour trigger
  useEffect(() => {
    const handleManualTour = () => {
      setIsManualTourActive(true);
    };
    
    window.addEventListener('startManualTour', handleManualTour);
    return () => window.removeEventListener('startManualTour', handleManualTour);
  }, []);

  function isVisible(el) {
    return el && el.offsetParent !== null; // đơn giản, đủ cho hầu hết case
  }

  const steps = [
    { 
      selector: '[data-tour="hello"]',  
      content: "Welcome to Gospel Truth Private! Here you'll grow in faith through guided thoughts and words." 
    },
    { 
      selector: '[data-tour="input"]',  
      content: "Type a word, question, or thought here to begin your journey of faith." 
    },
    { 
      selector: '[data-tour="suggested-prompts"]',  
      content: "Not sure what to ask? Choose one of these suggested questions to get started." 
    },
    { 
      selector: '[data-tour="song-to-sermon"]',  
      content: "Discover the Song to Sermon feature. Search and play songs from YouTube, then transform them into powerful, spirit filled devotionals and sermons." 
    },
    { 
      selector: '[data-tour="language-selector-desktop"], [data-tour="language-selector-mobile"]',  
      content: "Switch languages to experience God's word in the language that speaks to your heart." 
    },
    { 
      selector: "[data-tour='player-icons']",  
      content: "Here's what each option does:\n\n🎵 Golden Voice with Music – Hear the sermon in a unique golden voice.\n\n🎤 Special Voice – Listen in a distinct preaching style.\n\n🔊 Regular Sound – Hear it in a clear, natural tone.\n\n📥 Download Files – Save your sermon offline.\n\n🔗 Share – Send the message with others.\n\n📋 Copy Text – Copy sermon text instantly." 
    },
    { 
      selector: '[data-tour="sidebar-menu"]',  
      content: "Use the sidebar to explore features like creating new notes, video resources, help, settings, and premium tools." 
    },
    { 
      selector: '[data-tour="favorite-recent"]',  
      content: "Access your saved favorites and recent searches here anytime. Your faith journey is always just one click away." 
    },
    { 
      selector: '[data-tour="upgrade-button"], [data-tour="upgrade-button-mobile"]',  
      content: "Upgrade anytime to unlock unlimited features, deeper insights, and premium access." 
    },
    { 
      selector: '[data-tour="profile-icon"]',  
      content: "Manage your profile and account settings from here." 
    }
  ];

 

  return (
    <div className="App">
      <Sidebar />
      <ChatSection />
      <SettingSection />
      <SlideSection />
      <SubscriptionRequiredModal />
      {isShowCustomVoiceAddon && <CustomeVoiceAddon />}
      {isUserDetails && isLogin && <UserDetails />}
      {isAdvanceGeminiPrompt && (
        <div onClick={settingHandler} className="bg-focus-dark"></div>
      )}
      {isUserDetails && isLogin && (
        <div onClick={settingHandler} className="bg-focus-dark"></div>
      )}
      {/* Tiny centered anchor for the completion step (non-interactive, invisible) */}
      <div
        data-tour="completion"
        style={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: 2,
          height: 2,
          pointerEvents: 'none',
          zIndex: 2147483000
        }}
      />
      {((!isTourSeen && !isShowSlide && (slideClosed || hslideFlag) && tourCompletionCount < 1) || isManualTourActive) && (
        <ReactOnboardingTour
          steps={steps}
          tourId={isManualTourActive ? "walkthrough" : "chat-like"}
          version={isManualTourActive ? Date.now() : 2}
          autoStart={isManualTourActive ? false : true}
          shouldShowTour={isManualTourActive ? true : shouldShowTour}
          brandColor="#0ea5e9"
          disableGuard={isManualTourActive}
          saveSeenOnClose={!isManualTourActive}
          onOpenChange={(open) => {
            if (!open) {
              // Ensure sidebar returns to closed after tour ends
              if (isSidebarLong) dispatch(uiAction.toggleSideBar());
              // If this was manual walkthrough and user pressed Skip/Close, stop manual mode
              if (isManualTourActive) setIsManualTourActive(false);
            }
          }}
          onComplete={() => {
            if (!isManualTourActive) {
              // Only count auto tours, not manual walkthrough
              try {
                const currentCount = parseInt(localStorage.getItem('tour:chat-like:v2:count') || '0');
                const newCount = currentCount + 1;
                localStorage.setItem('tour:chat-like:v2:count', newCount.toString());
                setTourCompletionCount(newCount);
              } catch {}
              setIsCompletionModalOpen(true);
            } else {
              // Manual tour completed, just close it
              setIsManualTourActive(false);
            }
          }}
          onSkip={() => {
            if (!isManualTourActive) {
              // Count skip as a completion for auto tour
              try {
                const currentCount = parseInt(localStorage.getItem('tour:chat-like:v2:count') || '0');
                const newCount = currentCount + 1;
                localStorage.setItem('tour:chat-like:v2:count', newCount.toString());
                setTourCompletionCount(newCount);
              } catch {}
            }
            // Always close sidebar when skipping (overlay/click outside)
            if (isSidebarLong) dispatch(uiAction.toggleSideBar());
            // End manual mode if active
            if (isManualTourActive) setIsManualTourActive(false);
          }}
          prepareMap={{
          3: async () => {
            const plus = document.getElementById('plus-button');
            plus?.click();
            await new Promise(r => setTimeout(r, 150));
          },
          4: async () => {
            
            const width = window.innerWidth;
            // On mobile, language is inside the dropdown; open it before highlighting
            if (width < 768) {
              const plus = document.getElementById('plus-button');
              plus?.click();
              await new Promise(r => setTimeout(r, 200));
            }
          },
          6: async () => {
            // Open sidebar for step 6
            if (!isSidebarLong) dispatch(uiAction.toggleSideBar());
            // wait a tick to allow DOM/layout to settle before highlighting
            await new Promise(r => setTimeout(r, 200));
          },
          7: async () => {
            // Keep sidebar open for step 7
            if (!isSidebarLong) dispatch(uiAction.toggleSideBar());
            await new Promise(r => setTimeout(r, 200));
          },
          8: async () => {
            const width = window.innerWidth;
            // On mobile (<960px), upgrade button is in sidebar - ensure it's open
            if (width < 960 && !isSidebarLong) {
              dispatch(uiAction.toggleSideBar());
              await new Promise(r => setTimeout(r, 250));
            }
            // On desktop (>=960px), upgrade button is in header - ensure sidebar is closed
            else if (width >= 960 && isSidebarLong) {
              dispatch(uiAction.toggleSideBar());
              await new Promise(r => setTimeout(r, 150));
            }
          },
          9: async () => {
            if (isSidebarLong) dispatch(uiAction.toggleSideBar());
            await new Promise(r => setTimeout(r, 200));
          }
        }}
          stepHooks={{
          0: () => {
            const btn = document.querySelector('[data-tour="hello"]');
            if (!btn) return;
            btn.classList.add("tour-pulse");
            setTimeout(() => btn.classList.remove("tour-pulse"), 1200);
          },
          1: () => {
            const input = document.querySelector('[data-tour="input"]');
            if (!input) return;
            input.classList.add("tour-pulse");
            setTimeout(() => input.classList.remove("tour-pulse"), 1200);
          },
          2: () => {
            const prompts = document.querySelector('[data-tour="suggested-prompts"]');
            if (!prompts) return;
            prompts.classList.add("tour-pulse");
            setTimeout(() => prompts.classList.remove("tour-pulse"), 1200);
          },
          3: () => {
            // Wait a bit for dropdown to appear, then highlight
            setTimeout(() => {
              const btn = document.querySelector('[data-tour="song-to-sermon"]');
              if (!btn) {
                return;
              }
              btn.classList.add("tour-pulse");
              setTimeout(() => btn.classList.remove("tour-pulse"), 1200);
            }, 300);
          },
          4: () => {
            // Wait for dropdown to settle, then highlight appropriate language selector
            setTimeout(() => {
              const width = window.innerWidth;
              let lang;
              
              if (width < 768) {
                // Mobile: check dropdown language selector first
                lang = document.querySelector('[data-tour="language-selector-mobile"]');
              } else {
                // Desktop: check header language selector
                lang = document.querySelector('[data-tour="language-selector-desktop"]');
              }
              
              if (!lang) return;
              lang.classList.add("tour-pulse");
              setTimeout(() => lang.classList.remove("tour-pulse"), 1200);
            }, 350);
          },
          5: () => {
            const icons = document.querySelector('[data-tour="player-icons"]');
            if (!icons) return;
            icons.classList.add("tour-pulse");
            setTimeout(() => icons.classList.remove("tour-pulse"), 1200);
          },
          6: () => {
            const sidebar = document.querySelector('[data-tour="sidebar-menu"][data-expanded="1"]');
            if (!sidebar) return;
            sidebar.classList.add("tour-pulse");
            setTimeout(() => sidebar.classList.remove("tour-pulse"), 1200);
          },
          7: () => {
            const favorite = document.querySelector('[data-tour="favorite-recent"]');
            if (!favorite) return;
            favorite.classList.add("tour-pulse");
            setTimeout(() => favorite.classList.remove("tour-pulse"), 1200);
          },
          8: () => {
            // Wait for sidebar animation to complete, then highlight appropriate upgrade button
            setTimeout(() => {
              const width = window.innerWidth;
              let upgrade;
              
              if (width < 960) {
                // Mobile: upgrade button in sidebar
                upgrade = document.querySelector('[data-tour="upgrade-button-mobile"]');
              } else {
                // Desktop: upgrade button in header
                upgrade = document.querySelector('[data-tour="upgrade-button"]');
              }
              
              if (!upgrade || !isVisible(upgrade)) {
                return;
              }
              upgrade.classList.add("tour-pulse");
              setTimeout(() => upgrade.classList.remove("tour-pulse"), 1200);
            }, 350);
          },
          9: () => {
            const profile = document.querySelector('[data-tour="profile-icon"]');
            if (!profile) return;
            profile.classList.add("tour-pulse");
            setTimeout(() => profile.classList.remove("tour-pulse"), 1200);
          },
          10: () => {}
        }}
        />
      )}

      {isCompletionModalOpen && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 flex items-center justify-center"
          style={{ zIndex: 2147483647 }}
        >
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setIsCompletionModalOpen(false)}
          />
          <div
            className="relative bg-white rounded-2xl shadow-2xl p-6  max-w-sm border border-gray-200"
          >
            <h3 className="text-xl text-left font-semibold text-[#14A6EA] mb-2">You're all set!</h3>
            <p className="text-slate-600 mb-4 text-left">
              Create inspiring sermons and let your words make an impact.
            </p>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setIsCompletionModalOpen(false);
                  // After first completion, permanently block
                  if (tourCompletionCount >= 1) {
                    setIsTourSeen(true);
                  }
                }}
                className="px-4 py-2 rounded-md text-white bg-[#14A6EA]"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
